import React, { useEffect, useState } from 'react';
import { LanguageProvider } from './LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Program } from './components/Program';
import { HowItWorks } from './components/HowItWorks';
import { Testimonial } from './components/Testimonial';
import { Faq } from './components/Faq';
import { Booking } from './components/Booking';
import { Footer } from './components/Footer';
import { Seo } from './components/Seo';
export function App() {
  // Render the top of the page (Header, Hero, PainPoints) immediately so the
  // browser can finish loading fast and clear its loading bar. The remaining
  // sections — and only then the heavy Cal.com widget — mount right after the
  // first paint, during browser idle time.
  const [showRest, setShowRest] = useState(false);
  useEffect(() => {
    const reveal = () => setShowRest(true);
    const idle = (window as any).requestIdleCallback;
    const id = idle ? idle(reveal, {
      timeout: 1500
    }) : window.setTimeout(reveal, 200);
    return () => {
      if (idle && (window as any).cancelIdleCallback) {
        ;
        (window as any).cancelIdleCallback(id);
      } else {
        window.clearTimeout(id as number);
      }
    };
  }, []);
  return <LanguageProvider data-id="element-0">
      <Seo data-id="element-1" />
      <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-indigo-200 selection:text-indigo-900" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <PainPoints data-id="element-6" />
          {showRest && <>
              <Program data-id="element-7" />
              <HowItWorks data-id="element-8" />
              <Testimonial data-id="element-9" />
              <Faq data-id="element-10" />
              <Booking data-id="element-11" />
            </>}
        </main>
        {showRest && <Footer data-id="element-12" />}
      </div>
    </LanguageProvider>;
}